import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../../types/store'
import {
    alertErrorMessage,
    throwSuccessMessage,
} from '../../../../utils/Errors'
import { fetchProductsGroups } from './fetchProductsGroups'
import { IProductGroup } from '../../../../types/product'
import { hideModal } from '../../../actions/modalActions'
import { getUrlWithVersion } from '../../../../api/api'

export const createProductsGroup = createAsyncThunk<
    void,
    { data: IProductGroup },
    ThunkConfig<string>
>('productsSlice/createProductsGroup', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
        dispatch,
    } = thunkAPI

    const { data } = args

    try {
        await api.post(getUrlWithVersion(`/groups`), { ...data, position: 0 })
        dispatch(fetchProductsGroups())
        dispatch(hideModal())
        throwSuccessMessage(`Group ${data.name} created!`)
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to create a group')
    }
})
